import { request } from '@/util/request'
// import AES from '@/util/AES'
/**
 * @name GetChannelDetailByChannelNo
 * @desc 移动端根据工号与姓名获取机构信息
 * @params {object} data
 * @param {string} data.channelNo 机构名称
 * @param {string} data.contactsName 联系人

 联系人
 * */
export function GetChannelDetailByChannelNo(data = {}, loadingConfig) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/channelResource/getChannelDetailByChannelNo`,
    method: 'get',
    params: data,
    loadingConfig
  })
}

/**
 * @name GetGalleryList
 * @desc 获取海报列表
 * @params {object} data
 * @param {string} data.channelNo 机构名称
 * @param {string} data.contactsName 联系人
 * */

export function GetGalleryList(data = {}, loadingConfig) {
  data.busType = 'posters'
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/galleryResource/getGalleryLists`,
    method: 'get',
    params: data,
    loadingConfig
  })
}

/**
 * @name outputPosterFile
 * @desc 生成海报
 * @params {object} data
 * @param {string} data.channelId 渠道主键
 * @param {string} data.imgId 海报主键
 * @param {string} data.insuredUrl 投保地址
 * 
 * * @param {string} data.token 
 * @param {string} data.agentUserId 代理人id
 * @param {string} data.imgId 海报图片id
 * @param {string} data.insuredUrl 投保链接
 
 * */
//  /services/front/channelResource/createPosterFile
export function outputPosterFile(data = {}, loadingConfig) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/channelResource/createPosterFile`,
    method: 'POST',
    data,
    responseType: 'blob',
    // responseType: 'arraybuffer',
    loadingConfig
  })
}

/**
 * @name ActivePosterFile
 * @desc 激活海报
 * @params {object} data
 * @param {string} data.id 渠道主键
 * @param {string} data.isEffective 海报主键 1
 * */
export function ActivePosterFile(data = {}, loadingConfig) {
  data.isEffective = '1'
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/channelResource/updateChannelEffectiveStatus`,
    method: 'POST',
    data,
    loadingConfig
  })
}

/**
 * @name agentUserLogin
 * @desc 登录注册
 * @param {object} params
 * @param {string} params.mobilePhone
 * @param {string} params.captcha
 *

 * */
// /services/front/wechatUser/getVerificationCode
export function agentUserLogin(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/agentUserResource/agentUserLogin`,
    method: 'GET',
    params,
    loadingConfig
  })
}

// 工号登陆
export function agentUserEmployeeNoLogin(data = {}, loadingConfig = {}) {
  // data.pwd = AES.encrypt(data.pwd, 'MIGfMA0GCSqGSIb3')
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/agentUserResource/agentUserEmployeeNoLogin`,
    method: 'POST',
    data,
    loadingConfig
  })
}

/**
 * @name getDistributionDepartmentList
 * @desc 获取所有所属机构
 
 * */
// /services/front/wechatUser/getVerificationCode
export function getDistributionDepartmentList(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/distributionDepartmentResource/getDistributionDepartmentList`,
    method: 'GET',
    params,
    loadingConfig
  })
}

/**
 * @name getDepartmentByParentCode
 * @desc 获取所有所属机构
 
 * */
// /services/front/wechatUser/getVerificationCode
export function getDepartmentByParentCode(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/distributionDepartmentResource/getDepartmentByParentCode`,
    method: 'GET',
    params,
    loadingConfig
  })
}


/**
 * @name agentUserLogin
 * @desc 实名姓名机构
 * @param {object} data
 * @param {string} data.userName
 * @param {string} data.agentDepartCode
 *

 * */
// 
export function improveAccountInformation(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/agentUserResource/improveAccountInformation `,
    method: 'POST',
    data,
    loadingConfig
  })
}

/**
 * @name findAgentUserById
 * @desc 根据代理人id查询详情
 * @param {object} params
 * @param {string} params.id
 * @param {string} params.token
 *

 * */

export function findAgentUserById(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/agentUserResource/findAgentUserById`,
    method: 'GET',
    params,
    loadingConfig
  })
}

/**
 * @name findUserInsurancePage
 * @desc 保单分页条件查询
 * @param {object} params
 * @param {string} params.pageNum
 * @param {string} params.pageSize
 * @param {string} params.id
 * @param {string} params.type
 * @param {string} params.token
 *

 * */
// /services/front/agentUserResource/findUserInsurancePage
export function findUserInsurancePage(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/agentUserResource/selectPolicysByFromSourcePage`,
    method: 'GET',
    params,
    loadingConfig
  })
}

// 工号登陆
export function agentUserUpdatePassword(data = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/agentUserResource/agentUserUpdatePassword`,
    method: 'POST',
    data,
    loadingConfig
  })
}